import { createActionGroup, props } from '@ngrx/store';
import { Certificate } from './certificate.state';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CertificateResolverActions = createActionGroup({
  source: 'Certificate Resolver',
  events: {
    'Certificates requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AppleDeviceApiActions = createActionGroup({
  source: 'Apple Device API',
  events: {
    'Certificates loaded': props<{ certificates: Certificate[] }>(),
    'Certificates loaded error': props<{ error: ErrorModel }>(),
  },
});
